import { FC } from 'react'

interface IMarkdownViewer {
  text: string
  className?: string
  classNameLink?: string
}

const MarkdownViewer: FC<IMarkdownViewer> = ({
  text,
  className,
  classNameLink,
}) => {
  const regex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g
  const parts = []
  let lastIndex = 0
  let match

  while ((match = regex.exec(text)) !== null) {
    const [fullMatch, linkText, url] = match
    const start = match.index

    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start))
    }

    parts.push(
      <a
        key={start}
        href={url}
        className={classNameLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkText}
      </a>,
    )

    lastIndex = regex.lastIndex
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return <p className={className}>{parts}</p>
}

export default MarkdownViewer
